import React from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  authActions,
  facilityAction,
  masterActions,
  menuActions,
} from "../../../_store";
import { useDispatch, useSelector } from "react-redux";
import { history } from "../../../_helpers";
import { setStoredValue } from "../../../_helpers/storagehelper";
function DropdownProfile() {
  const loggedUser = useSelector((x) => x?.auth?.user);

  const dispatch = useDispatch();

  const handleLogout = () => {
    setStoredValue("isLoggedIn", false); setStoredValue("logout-event", Date.now().toString()); 
    localStorage.setItem("logout-event", Date.now().toString());
    dispatch(authActions.logout());
    dispatch(facilityAction.resetFacilitySearch());
    dispatch(authActions.removeCommonFaciityCode());
    //history.navigate("/facilityuser");
  };

  const handleChangePassword = () => {
    history.navigate("/Admin/ChangePassword");
  };

  const handleSupport = () => {
    history.navigate("/Admin/support");
  };
  return (
    <div className="navbar-item navbar-user dropdown">
      <a
        href="#/"
        className="navbar-link d-flex align-items-center"
        data-bs-toggle="dropdown"
      >
        <div className="image image-icon bg-gray-800 text-gray-600">
          <i className="fa fa-user"></i>
        </div>
        <span>
          <div className="d-flex flex-column">
            <div
              className="d-none d-md-inline fs-5 user-name"
              style={{ color: "#232d42", fontWeight: "400" }}
            >
              {loggedUser?.FullName}
              <b className="caret"></b>
            </div>

            <div className="d-none d-md-inline user-role">
              {loggedUser?.UserRoleName}
            </div>
          </div>
        </span>
      </a>
      <div className="dropdown-menu dropdown-menu-end me-1">
        <a
          //  href="#"
          onClick={(e) => {
            e.preventDefault();
          }}
          className="d-md-none fs-5 user-name"
        >
          {loggedUser?.FullName}
        </a>
        <a
          //href="#"
          onClick={(e) => {
            e.preventDefault();
          }}
          className="dropdown-item d-md-none fs-5 user-role"
        >
          {loggedUser?.UserRoleName}
        </a>
        <li className="dropdown-item d-md-none fs-5 border-bottom"></li>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            handleSupport();
          }}
          className="dropdown-item"
        >
          Support
        </a>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            handleChangePassword();
          }}
          className="dropdown-item"
        >
          Change Password
        </a>
        {/* <Link onClick={handleChangePassword} className="dropdown-item">
          Change Password
        </Link> */}
        <span
          style={{ cursor: "Pointer" }}
          className="dropdown-item"
          onClick={handleLogout}
        >
          Logout
        </span>
      </div>
    </div>
  );
}

export default DropdownProfile;
